import axios from "axios";
import config from "../config";
import authHeader from "./auth-header";
import { encodeQueryValue } from "./queryString";
import { withoutLegacyAuthority } from "./requestPayload";
import { catalogLegacyQuery, catalogListLimit, localCatalogAction } from "./catalogRequest";
import { normalizeCategoryMutationValues } from "../pages/services/categories/categoryFormValues";

const API_URL = config.API_URL;
const hasValue = (value) => value !== undefined && value !== null && String(value).trim() !== "";

const create = (values) => {
  const action = "afterlogin/categories/store";
  return axios.post(API_URL + action, withoutLegacyAuthority(normalizeCategoryMutationValues(values)), { headers: authHeader() });
};

const update = (values) => {
  const data = withoutLegacyAuthority(normalizeCategoryMutationValues(values));
  if (data.gender && typeof data.gender === "object") data.gender = data.gender.value;
  const action = "afterlogin/categories/update/" + values.id;
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const view = (values) => {
  const sort = values && values.sort;
  const result = values && values.result ? values.result : "";
  const fromPosition = values && values.fromPosition;
  const toPosition = values && values.toPosition;
  const q = typeof (values && values.q) === "string" ? values.q.trim() : catalogLegacyQuery(values, "q") || "";
  const encodedQ = encodeQueryValue(q);
  let sortstring = "";
  if (sort) {
    let sortArray = [];
    Object.keys(sort).map(function (key, index) {
      return (sortArray[index] = `sort[${key}]=${sort[key]}`);
    });
    if (sortArray.length > 0) {
      let jsort = sortArray.join("&");
      sortstring = jsort;
    }
  }
  let pagination = true;
  if (values) {
    if (values.id) {
      pagination = false;
    }
    if (values.option) {
      pagination = false;
    }
    if (typeof values.pagination === "boolean") {
      pagination = values.pagination;
    }
  }
  const query = [sortstring, q ? `q=${encodedQ}` : ""].filter(Boolean).join("&");
  const action = localCatalogAction("afterlogin/categories/view", values, query);
  const data = {
    pagination: pagination, //true or false
    id: values && values.id ? values.id : "",
    result: result, //business_name,owner_name
    option: values && values.option ? values.option : "",
  };
  if (q) {
    data.apicall = "suggetion";
    data.q = q;
  }
  const limit = catalogListLimit(values);
  if (limit) data.limit = limit;
  if (hasValue(fromPosition)) data.fromPosition = fromPosition;
  if (hasValue(toPosition)) data.toPosition = toPosition;
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const subscriptionView = (values) => {
  const sort = values && values.sort;
  const result = values && values.result ? values.result : "";
  const fromPosition = values && values.fromPosition ? values.fromPosition : "";
  const toPosition = values && values.toPosition ? values.toPosition : "";
  let sortstring = "";
  if (sort) {
    let sortArray = [];
    Object.keys(sort).map(function (key, index) {
      return (sortArray[index] = `sort[${key}]=${sort[key]}`);
    });
    if (sortArray.length > 0) {
      let jsort = sortArray.join("&");
      sortstring = jsort;
    }
  }
  let pagination = true;
  if (values) {
    if (values.id) {
      pagination = false;
    }
    if (values.option) {
      pagination = false;
    }
    if (typeof values.pagination === "boolean") {
      pagination = values.pagination;
    }
  }
  const action = localCatalogAction("afterlogin/subscription/view", values, sortstring);
  const data = {
    formName:'bookingLink/subscription',
    pagination: pagination, //true or false
    id: values && values.id ? values.id : "",
    result: result, //business_name,owner_name
    option: values && values.option ? values.option : "",
  };
  const limit = catalogListLimit(values);
  if (limit) data.limit = limit;
  if (hasValue(fromPosition)) data.fromPosition = fromPosition;
  if (hasValue(toPosition)) data.toPosition = toPosition;
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const deleted = (values) => {
  const action = `afterlogin/categories/delete/${values.id}`;
  const data = {};
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const suggetionlist = (values) => {
  let q = typeof (values && values.q) === "string" ? values.q : catalogLegacyQuery(values, "q") || "";
  const encodedQ = encodeQueryValue(q);
  const action = localCatalogAction("afterlogin/categories/view", values, `q=${encodedQ}`);
  const data = {
    pagination: true, //true or false
    apicall: "suggetion",
    id: values && values.id ? values.id : "",
    q,
  };
  const limit = catalogListLimit(values);
  if (limit) data.limit = limit;
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const categoryApiController = {
  create,
  update,
  view,
  deleted,
  subscriptionView,
  suggetionlist,
};
export default categoryApiController;
